module.exports = __webpack_public_path__ + "img/bootSpeedioWtf.8c4223b1.svg";